/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2023
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import urlJoin from 'proper-url-join';

export const SERVICE_ROLES = {
  MANAGER: 'Manager',
  WRITER: 'Writer',
  READER: 'Reader',
  CREATOR: 'Creator',
  UNAVAILABLE: 'Unavailable'
};

export const ACCESS_CONTROL_STATUS = {
  ON: true,
  OFF: false
};

export const DEFAULT_INSTANCE_ACCESS_CONTROL_STATUS = {
  accessControlStatus: ACCESS_CONTROL_STATUS.OFF,
  role: SERVICE_ROLES.MANAGER
};

export const READ_ONLY_TYPE = {
  INSTANCE: 'instance',
  ASSISTANT: 'assistant',
  SKILL: 'skill'
};

/**
 * Takes the incoming path string and prepends either just "/v2" for
 * old style (useUpdatedAccess = false) or the longer "/v2/assistants/${assistantId}"
 * which allows updated (assistant-ID-based) access control
 * @param {boolean} useUpdatedAccess  selects longer url if true
 * @param {string} assistantId added to longer update-true url
 * @param {string} path the remaining path string which will get the prefix substring
 * @returns {string} the final path with prefix
 */
export const getAccessPrefixedUrl = (
  useUpdatedAccess: boolean,
  assistantId: string,
  path: string
): string => {
  const prefix = useUpdatedAccess ? `/v2/assistants/${assistantId}` : '/v2';
  return urlJoin(prefix, path);
};
